import { render, staticRenderFns } from "./vehicleViolationEdit.vue?vue&type=template&id=55b1cdb3&scoped=true"
import script from "./vehicleViolationEdit.vue?vue&type=script&lang=js"
export * from "./vehicleViolationEdit.vue?vue&type=script&lang=js"
import style0 from "./vehicleViolationEdit.vue?vue&type=style&index=0&id=55b1cdb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1cdb3",
  null
  
)

export default component.exports